import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import './ChannelItem.scss';
import ChannelActivationModal from '../ChannelActivationModal/ChannelActivationModal';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const ChannelItem = (props) => {
  const { channel, activeChannels, t, history, match: { params: { adId, }, }, } = props;
  const [isChannelActivationModalOpen, setIsChannelActivationModalOpen] = useState(false);
  const handleButtonClick = () => {
    if (channel.acitve) {
      return history.push(`/dashboard/ads/${adId}/promote/${channel.uniq_name}`);
    }
    return setIsChannelActivationModalOpen(true);
  };

  return (
    <div className="channel-item">
      <ChannelActivationModal
        isOpen={isChannelActivationModalOpen}
        closeModal={() => setIsChannelActivationModalOpen(false)}
        channel={channel}
      />
      <p><img alt="logo" src={get(channel, 'logo_url')} /></p>
      <h4>{get(channel, 'name')}</h4>
      <button
        className="btn button-default"
        onClick={() => handleButtonClick()}
        disabled={activeChannels.includes(channel.id)}
      >
        {t('activate')}
      </button>
    </div>
  );
};

ChannelItem.propTypes = {
  channel: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  activeChannels: PropTypes.arrayOf(PropTypes.number).isRequired,
};


export default withRouter(withScopedTranslations('ads.channels')(ChannelItem));
